import { useEffect } from "react";
import { dismissKeyboard, isInputElement } from "../keyboardUtils";

export const useDismissKeyboard = () => {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent | TouchEvent) => {
      const target = e.target as HTMLElement;

      if (!isInputElement(target)) {
        dismissKeyboard();
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("touchend", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchend", handleClickOutside);
    };
  }, []);
};
